import { Options, Vue } from 'vue-property-decorator';

export const regexLowerCase = /^(?=.*[a-z])/;
export const regexPasswordLength = /^(?=.{8,})/;
export const regexUpperCase = /^(?=.*[A-Z])/;
export const regexSpecialLetters = /[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`=+ ]/;

@Options({})
export default class PasswordMixin extends Vue {
  public isLowerCase(value: string) {
    if (regexLowerCase.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  public isLengthAccepted(value: string) {
    if (regexPasswordLength.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  public isCapitalized(value: string) {
    if (regexUpperCase.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  public isSignExists(value: string) {
    if (regexSpecialLetters.test(value)) {
      return true;
    } else {
      return false;
    }
  }

  public passwordValidation(value: string) {
    if (
      this.isLowerCase(value) &&
      this.isLengthAccepted(value) &&
      this.isCapitalized(value) &&
      this.isSignExists(value)
    ) {
      return true;
    }
    return '';
  }
}
